import React, {useRef, useState} from "react";
import {Img} from "react-image";
import {PlaceholderImgIcon} from "../../../../icons/PlaceholderImgIcon";
import {LoadingSpinner} from "../../../../icons/LoadingSpinner";
import {useOutsideClick} from "../../../../../hooks/useOutsideClick";

export const InteractiveMenuItemImage = ({src, hasImage}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const imageRef = useRef(null);

    useOutsideClick([imageRef], () => setIsExpanded(false), isExpanded);

    const commonProps = {
        alt: "MenuPreview item preview",
        src,
        className: "menu-item-position-image",
        loader: <div className="image-loader"><LoadingSpinner buttonMode={true}/></div>,
        unloader: <PlaceholderImgIcon/>
    };

    const handleExpansion = () => {
        if (!hasImage) return;
        setIsExpanded(!isExpanded);
    }

    return (
        <div className={'menu-item-position-image-container'}
             ref={imageRef}
             onClick={handleExpansion}
             style={hasImage ? {cursor: isExpanded ? 'zoom-out' : 'zoom-in'} : {}}>
            <Img {...commonProps}/>
            {isExpanded && (
                <Img{...commonProps} className={`menu-item-position-image is-expanded`}
                />
            )}
        </div>
    );
};